import { Component, Input, OnInit } from '@angular/core';
import { handleRatio } from 'src/app/_classes';
import { GeneratedTimelineCardData } from 'src/app/_interfaces';

import { YoutubeVideoPlayerComponent } from '../youtube-video-player/youtube-video-player.component';
import { StandloneCardComponent } from './standlone-card/standlone-card.component';
import { WebviewCardComponent } from './webview-card/webview-card.component';
import { BroadcastScheduledCardComponent } from './broadcast-scheduled-card/broadcast-scheduled-card.component';

@Component({
    selector: 'app-timeline-card',
    templateUrl: './timeline-card.component.html',
    styleUrls: ['./timeline-card.component.scss'],
    imports: [YoutubeVideoPlayerComponent, StandloneCardComponent, WebviewCardComponent, BroadcastScheduledCardComponent]
})
export class TimelineCardComponent implements OnInit {
    @Input() timeline_id!: string;
    @Input() timeline_item!: GeneratedTimelineCardData;
    public aspect_ratio: string = '';

    constructor() { }

    ngOnInit(): void {
        this.aspect_ratio = handleRatio(this.timeline_item);
    }
}
